import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import "../../../cssfiles/homepage.css";
import AssetTagsRetrieval from "./AssetTagsRetrieval";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Paper from "@mui/material/Paper";
import {
  getdevicetags1,
  postuniquealarmconfig,
  getNotification,
  getNotifcationUserGroups,
  postNotification,
} from "../../../Restclient/datacollection";
import CustomCancelButton from "../../CommonComponents/CustomCancelButton";
import CustomTableHeading from "../../CommonComponents/CustomTableHeading";
import CustomActionButton from "../../CommonComponents/CustomActionButton";
import CustomDialogBox from "../../CommonComponents/CustomDialogBox";
import CustomTableMetric from "../../CommonComponents/CustomTableMetric";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import LK_Delete from "../../../images/LK_Delete";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import { Checkbox } from "@mui/material";

const renderTreeNodes = (node, checkedNode, devicename, deviceId) => {
  if (node.hasOwnProperty("Userid") && node.hasOwnProperty("UserName")) {
    return (
      <TreeItem
        key={deviceId + node["Userid"]}
        itemId={deviceId + node["Userid"]}
        label={
          <Typography
            sx={{
              display: "flex",
              alignItems: "left",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <span style={{ color: "var(--SecondaryText)" }}>
              {node["UserName"]}
            </span>
          </Typography>
        }
        sx={{
          "& .MuiTreeItem-label": {
            fontSize: "16px",
            fontWeight: 400,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          },
        }}
      ></TreeItem>
    );
  }
};

export default function AlertRulesEdit(props) {
  function handleCancelChange() {
    props.setAlarmRulesEdit(false);
  }

  /*function handleSaveChange(){
        // console.log("props.uniquealarmcondition",props.uniquealarmcondition)
    }
    */

  const [existingDeviceTagAlarmConfig, setExistingDeviceTagAlarmConfig] =
    useState(false);
  const [
    existingDeviceTagAlarmConfigEdit,
    setExistingDeviceTagAlarmConfigEdit,
  ] = useState(false);
  const [selectedTag, setSelectedTag] = useState({
    projectid: props.uniquealarmcondition.alarmrule.ProjectID,
    TagID: props.uniquealarmcondition.alarmrule.TagID,
    tagname: props.uniquealarmcondition.alarmrule.Alias,
    tagunit: props.uniquealarmcondition.alarmrule.TagUnit,
    tagdatatype: props.uniquealarmcondition.alarmrule.TagDataType,
  });
  const [selectedAsset, setSelectedAsset] = useState({
    asset_name: props.uniquealarmcondition.alarmrule.DeviceName,
    device_id: props.uniquealarmcondition.alarmrule.DeviceID,
  });
  const themechange = useSelector((state) => state.themedata.theme);
  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate,
  );
  const selectedprojectname = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const [pagesize, setPagesize] = useState(370);
  const [configurationValidation, setConfigurationValidation] = useState({
    datavalidation: true,
    rangevalidation: true,
  });
  const [boolallconditionsfilled, setboolAllConditionsfilled] = useState(true);
  const [alarmrulefilled, setAlarmRulefilled] = useState(true);
  const [confirmAlarmTagset, setConfirmAlarmTagset] = useState(true);
  const [assetdata, setAssetData] = useState(null);
  const [userGroups, setUserGroups] = useState([]);
  const [enableAlert, setenableAlert] = useState(
    Boolean(props.uniquealarmcondition.alarmrule.enableAlert),
  );
  const [sendMessage, setsendMessage] = useState(
    Boolean(props.uniquealarmcondition.alarmrule.SendMessage),
  );
  const [sendEmail, setsendEmail] = useState(
    Boolean(props.uniquealarmcondition.alarmrule.SendEmail),
  );
  const [
    enablehighestprioritynotification,
    setenablehighestprioritynotification,
  ] = useState(false);
  const [enablehighprioritynotification, setenablehighprioritynotification] =
    useState(false);
  const [
    enablemediumprioritynotification,
    setenablemediumprioritynotification,
  ] = useState(false);
  const [enablelowprioritynotification, setenablelowprioritynotification] =
    useState(false);
  const [currentUserNotificationRuleId, setCurrentUserNotificationRuleId] =
    useState("");
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const [checkedNode, setCheckedNode] = useState(null); //z Holds the id of the currently checked node
  const [checkedNodes, setCheckedNodes] = useState([]);
  const [ruleusergroup, setruleusergroup] = useState([]);
  const [overallruleusergroup, setoverallruleusergroup] = useState([]);
  const [assetdataerror, setAssetDataError] = useState(false);
  const tagdetailsobject = useSelector(
    (state) => state.mainpagedata.tagdetailsobject,
  );
  /* Extra States */
  const [numConditions, setNumConditions] = useState(
    props.uniquealarmcondition.alarmrule.conditions.length,
  ); // Default number of conditions
  const [showTable, setShowTable] = useState(true); // Whether to display the table

  const [conditions, setConditions] = useState(
    props.uniquealarmcondition.alarmrule.conditions,
  ); // Store conditions entered by the user
  const [boolconditions, setBoolConditions] = useState(
    props.uniquealarmcondition.alarmrule.conditions,
  ); // Store conditions entered by the user for boolean data type
  const [tempConditions, setTempConditions] = useState([]);
  const [conflictingConditionsGroups, setConflictingConditionsGroups] =
    useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [objecttosavealarmrule, setObjecttosavealarmrule] = useState({});
  const [openAtLeastOneConditionDialog, setopenAtLeastOneConditionDialog] =
    useState(false);
  const [openMaxConditionDialog, setopenMaxConditionDialog] = useState(false);
  const [openAlarmUpdatedandSaved, setopenAlarmUpdatedandSaved] =
    useState(false);
  const [openAlarmUpdatedandSavedMsg, setopenAlarmUpdatedandSavedMsg] =
    useState(false);
  const [openAlarmUpdatedandSavedErr, setopenAlarmUpdatedandSavedErr] =
    useState(false);
  const [openAlarmUpdatedandSavedMsgErr, setopenAlarmUpdatedandSavedMsgErr] =
    useState(false);
  const [openDuplicateAlarm, setopenDuplicateAlarm] = useState(false);
  const [userGroupsError, setUserGroupsError] = useState(false);
  //Extra States

  useEffect(() => {
    //// console.log("overviewstate ",overviewstate)
    if (overviewstate) {
      setPagesize(323);
    } else {
      setPagesize(288);
    }
  }, [overviewstate]);

  useEffect(() => {
    //getalarmgroups(alarmgroupscallback)
    if (
      props.uniquealarmcondition.alarmrule.enableAlert == true ||
      props.uniquealarmcondition.alarmrule.enableAlert == "true"
    ) {
      setenableAlert(true);
    } else if (
      props.uniquealarmcondition.alarmrule.enableAlert == false ||
      props.uniquealarmcondition.alarmrule.enableAlert == "false"
    ) {
      setenableAlert(false);
    }

    if (
      props.uniquealarmcondition.alarmrule.SendEmail == true ||
      props.uniquealarmcondition.alarmrule.SendEmail == "true"
    ) {
      setsendEmail(true);
    } else if (
      props.uniquealarmcondition.alarmrule.SendEmail == false ||
      props.uniquealarmcondition.alarmrule.SendEmail == "false"
    ) {
      setsendEmail(false);
    }

    if (
      props.uniquealarmcondition.alarmrule.SendMessage == true ||
      props.uniquealarmcondition.alarmrule.SendMessage == "true"
    ) {
      setsendMessage(true);
    } else if (
      props.uniquealarmcondition.alarmrule.SendMessage == false ||
      props.uniquealarmcondition.alarmrule.SendMessage == "false"
    ) {
      setsendMessage(false);
    }
    // getdevicetags1(userdetails.Projectid,assetcallback)
    if (
      selectedprojectname != undefined ||
      selectedprojectname != null ||
      selectedprojectname != ""
    ) {
      if (userdetails && userdetails.Projectid && userdetails.Projectlist) {
        //getalarmgroups(alarmgroupscallback)
        getdevicetags1(
          selectedprojectname,
          userdetails.Projectlist,
          assetcallback,
        );
        // getNotifcationUserGroups(selectedprojectname,userdetails.Projectlist,getNotifcationUserGroupscallback)
        /* getalarmevents(alarmeventscallback)*/
      }
    }
    setConditions(props.uniquealarmcondition.alarmrule.conditions);
    setBoolConditions(props.uniquealarmcondition.alarmrule.conditions);
    /* getalarmevents(alarmeventscallback)*/
  }, []);

  // const alarmgroupscallback = (res) => {
  //     // console.log("res obtd in alarmgroupscallback",res)
  //     // console.log("props.uniquealarmcondition-//////////",props.uniquealarmcondition)
  //     //setData(res);
  // };

  useEffect(() => {
    // Fetch notification groups and user groups sequentially
    async function fetchData() {
      try {
        // Step 1: Fetch notification groups for this rule
        const datareceived = await new Promise((resolve) =>
          getNotification(selectedTag.TagID, resolve),
        );

        let currentruleusergroup = [];
        //console.log("getNotificationcallback-datareceived", datareceived);

        if (
          datareceived &&
          datareceived?.success &&
          datareceived?.code == 200
        ) {
          setCurrentUserNotificationRuleId(
            datareceived?.notificationlist[0]?.id,
          );
          setenablehighestprioritynotification(
            datareceived?.notificationlist[0]?.HighestPriority == "true",
          );
          setenablehighprioritynotification(
            datareceived?.notificationlist[0]?.HighPriority == "true",
          );
          setenablemediumprioritynotification(
            datareceived?.notificationlist[0]?.MediumPriority == "true",
          );
          setenablelowprioritynotification(
            datareceived?.notificationlist[0]?.LowPriority == "true",
          );

          currentruleusergroup =
            datareceived?.notificationlist[0]?.NotificationGroups || [];

          setruleusergroup(currentruleusergroup);
        }

        // Step 2: Fetch all user groups after ruleusergroup is set
        var usergroupdata = await new Promise((resolve) =>
          //getNotifcationUserGroups(userdetails.Projectid, resolve)
          {
            if (
              selectedprojectname != undefined ||
              selectedprojectname != null ||
              selectedprojectname != ""
            ) {
              if (
                userdetails &&
                userdetails.Projectid &&
                userdetails.Projectlist
              ) {
                //getalarmgroups(alarmgroupscallback)
                //getdevicetags1(selectedprojectname,userdetails.Projectlist, assetcallback)
                // getNotifcationUserGroups(selectedprojectname,userdetails.Projectlist,getNotifcationUserGroupscallback)
                getNotifcationUserGroups(
                  selectedprojectname,
                  userdetails.Projectlist,
                  resolve,
                );
                /* getalarmevents(alarmeventscallback)*/
              }
            }
          },
        );
        usergroupdata = usergroupdata?.data;
        const currentcheckedusersarray = [];

        if (usergroupdata && usergroupdata?.length > 0) {
          usergroupdata.forEach((group) => {
            if (currentruleusergroup.includes(group?.id)) {
              currentcheckedusersarray.push({
                ProjectID: group?.ProjectID,
                groupName: group?.groupName,
                id: group?.id,
                users: group?.users,
                ...group,
              });
            }
          });

          setCheckedNodes(currentcheckedusersarray);
          setUserGroups(usergroupdata);
          setUserGroupsError(false);
        } else if (!usergroupdata || !Array.isArray(usergroupdata)) {
          setUserGroupsError(true);
          setUserGroups([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData();
  }, [selectedTag.TagID, selectedprojectname]);

  const assetcallback = (res, status) => {
    if (status == 200) {
      setAssetData(res?.data);
      setAssetDataError(false);
    } else {
      setAssetData({ devices: [] });
      setAssetDataError(true);
    }
  };

  const alarmeventscallback = (res) => {
    // console.log("res obtd in alarmeventscallback",res.data)
  };

  // Handle closing the dialog
  const handleClose = () => {
    setOpen(false);
  };

  /*const handleConfirm = () => {
        setConditions(tempConditions);
        setShowTable(true);
        setOpenConfirmDialog(false);
    };*/

  const handleConditionChange = (index, field, value) => {
    var updatedConditions;

    //TAGDATATYPE COMMENT
    if (
      (props.uniquealarmcondition.alarmrule.TagDataType == "bool" &&
        !props.uniquealarmcondition.alarmrule.Alert_rule_name.includes(
          "clone",
        )) ||
      (selectedTag.tagdatatype == "bool" &&
        props.uniquealarmcondition.alarmrule.Alert_rule_name.includes("clone"))
    ) {
      updatedConditions = conditions.map((condition, i) =>
        i === index ? { ...condition, [field]: value } : condition,
      );
      updatedConditions[index]["condition"] = "=";
      updatedConditions[index]["setpoint1"] =
        updatedConditions[index]["type"] == "True"
          ? "1"
          : updatedConditions[index]["type"] == "False"
            ? "0"
            : "";
      updatedConditions[index]["setpoint2"] = "";
    } else {
      updatedConditions = conditions.map((condition, i) =>
        i === index ? { ...condition, [field]: value } : condition,
      );
    }

    setConditions(updatedConditions);
  };

  // function handleConfirmationDuplicateAlarm(){
  //     setopenDuplicateAlarm(false);
  //     console.log("pqs")
  // }

  // function handleCloseDuplicateAlarm(){
  //     setopenDuplicateAlarm(false);
  // }

  const handleConfirmationAtLeastOneConditionDialog = () => {
    setopenAtLeastOneConditionDialog(false);
  };

  const handleCloseAtLeastOneConditionDialog = () => {
    setopenAtLeastOneConditionDialog(false);
  };

  const handleConfirmationMaxConditionDialog = () => {
    setopenMaxConditionDialog(false);
  };

  const handleCloseMaxConditionDialog = () => {
    setopenMaxConditionDialog(false);
  };

  // Add a new condition row
  const handleAddRow = () => {
    if (conditions.length >= 11) {
      setopenMaxConditionDialog(true);
      return;
    } else {
      setConditions([
        ...conditions,
        {
          type: "",
          condition: "",
          setpoint1: "",
          setpoint2: "",
          alarmpriority: "",
          normalmessage: "",
          abnormalmessage: "",
        },
      ]);
    }
  };

  // Remove a condition row
  const handleRemoveRow = (index) => {
    if (conditions.length == 1 && index == 0) {
      setopenAtLeastOneConditionDialog(true);
      return;
    }

    const updatedConditions = conditions.filter((_, i) => i !== index);
    setConditions(updatedConditions);
  };

  const [alarmrulename, setAlarmRuleName] = useState(
    props.uniquealarmcondition.alarmrule.Alert_rule_name,
  );
  const postuniquealarmconfigcallback = (res) => {
    if (res.success && res.code === 200) {
      setopenAlarmUpdatedandSaved(true);
      setopenAlarmUpdatedandSavedMsg(res.message);
      // Optionally show a success notification: showNotification(res.message, 'success');
    } else {
      // Optionally show an error notification: showNotification(res.message || 'Failed to update alert rule', 'error');
      console.error("Update failed:", res.message, res.error);
      setopenAlarmUpdatedandSavedErr(true);
      setopenAlarmUpdatedandSavedMsgErr(res.message);
    }
  };
  //props.uniquealarmcondition.alarmrule.selected_tag_name.std_tagname
  const doesOverlap = (range1, range2) => {
    const {
      lowerBound: l1,
      upperBound: u1,
      lowerCondition: lc1,
      upperCondition: uc1,
    } = range1;
    const {
      lowerBound: l2,
      upperBound: u2,
      lowerCondition: lc2,
      upperCondition: uc2,
    } = range2;

    // Handle upper bound and lower bound comparison
    const lowerBound1Satisfies =
      lc1 === ">=" ? Number(l1) <= Number(u2) : Number(l1) < Number(u2);
    const lowerBound2Satisfies =
      lc2 === ">=" ? Number(l2) <= Number(u1) : Number(l2) < Number(u1);

    const upperBound1Satisfies =
      uc1 === "<=" ? Number(u1) >= Number(l2) : Number(u1) > Number(l2);
    const upperBound2Satisfies =
      uc2 === "<=" ? Number(u2) >= Number(l1) : Number(u2) > Number(l1);

    return (
      lowerBound1Satisfies &&
      upperBound1Satisfies &&
      lowerBound2Satisfies &&
      upperBound2Satisfies
    );
  };

  // union find - Disjoint Set
  const find = (parent, i) => {
    if (parent[i] === i) return i;
    return (parent[i] = find(parent, parent[i]));
  };

  const union = (parent, rank, x, y) => {
    let rootX = find(parent, x);
    let rootY = find(parent, y);

    if (rootX !== rootY) {
      if (rank[rootX] > rank[rootY]) {
        parent[rootY] = rootX;
      } else if (rank[rootX] < rank[rootY]) {
        parent[rootX] = rootY;
      } else {
        parent[rootY] = rootX;
        rank[rootX]++;
      }
    }
  };

  const findConflictingGroups = (conditionsparameter) => {
    //console.log("conditionsparameter-findConflictingGroups",conditionsparameter)
    const n = conditionsparameter.length;
    const parent = Array(n)
      .fill()
      .map((_, i) => i);
    const rank = Array(n).fill(0);

    // Compare each condition with every other condition
    for (let i = 0; i < n; i++) {
      for (let j = i + 1; j < n; j++) {
        if (doesOverlap(conditionsparameter[i], conditionsparameter[j])) {
          union(parent, rank, i, j);
        }
      }
    }

    // groups from the union-find structure
    const groups = {};
    for (let i = 0; i < n; i++) {
      const root = find(parent, i);
      if (!groups[root]) {
        groups[root] = [];
      }
      groups[root].push(conditionsparameter[i]);
    }

    return Object.values(groups);
  };

  function validateConditions(conditions) {
    //console.log("handleSaveChange-validateConditions conditions OPERATE",conditions)
    var validdata = true;
    var validrange = true;
    //370 TO 553 TAGDATATYPE COMMENTED OUT

    switch (selectedTag.tagdatatype) {
      case "bool":
        //console.log("conditions bool",conditions)
        for (var i = 0; i < conditions.length; i++) {
          //console.log("bool for loop validdata",validdata)
          if (conditions[i].type == "") {
            //console.log("Hereinside-----validdata-----------recahed1",conditions[i].type)
            validdata = false;
          }
          //console.log("Hereafter -----validdata-----------recahed1",validdata)

          if (conditions[i].alarmpriority == "") {
            //console.log("Hereinside-----validdata-----------recahed2",conditions[i].alarmpriority)
            validdata = false;
          }
          //console.log("Hereafter -----validdata-----------recahed2",validdata)

          if (conditions[i].condition == "") {
            //console.log("Hereinside-----validdata-----------recahed3",conditions[i].condition)
            validdata = false;
          }
          //console.log("Hereafter -----validdata-----------recahed3",validdata)

          if (conditions[i].setpoint1 == "") {
            if (conditions[i].setpoint1 == "") {
              //console.log("THIS IS AN EMPTY STRING")
            } else if (conditions[i].setpoint1 != "") {
              //console.log("THIS IS NOT AN EMPTY STRING")
            }
            //console.log("Hereinside-----validdata-----------recahed4",conditions[i].setpoint1)
            validdata = false;
          }
          //console.log("Hereafter -----validdata-----------recahed4",validdata)

          // if((conditions[i].type == '') || (conditions[i].alarmpriority == '') || (conditions[i].condition == '') || (conditions[i].setpoint1 == '')){
          //     console.log("conditions[i].type========",conditions[i].type)
          //     console.log("conditions[i].alarmpriority========",conditions[i].alarmpriority)
          //     console.log("conditions[i].condition========",conditions[i].condition)
          //     console.log("conditions[i].setpoint1========",conditions[i].setpoint1)
          //     validdata = false;
          // }
          //console.log("after bool for loop validdata",validdata)
          if (
            Number(conditions[i].setpoint1) != 0 &&
            Number(conditions[i].setpoint1) != 1
          ) {
            //console.log("=conditions[i].setpoint1",conditions[i].setpoint1)
            validrange = false;
          }
        }
        //console.log("bool validrange",validrange,"validdata",validdata)
        break;
      case "int32":
        for (var i = 0; i < conditions.length; i++) {
          if (
            conditions[i].type == "" ||
            conditions[i].alarmpriority == "" ||
            conditions[i].condition == "" ||
            conditions[i].setpoint1 == ""
          ) {
            validdata = false;
          }

          if (conditions[i].type == "Ranges") {
            if (conditions[i].setpoint2 == "") {
              validdata = false;
            }

            if (
              Number(conditions[i].setpoint2) < -2147483648 ||
              Number(conditions[i].setpoint2) > 2147483647
            ) {
              validrange = false;
            }
          }

          if (
            Number(conditions[i].setpoint1) < -2147483648 ||
            Number(conditions[i].setpoint1) > 2147483647
          ) {
            validrange = false;
          }
        }
        break;
      case "uint32":
        for (var i = 0; i < conditions.length; i++) {
          if (
            conditions[i].type == "" ||
            conditions[i].alarmpriority == "" ||
            conditions[i].condition == "" ||
            conditions[i].setpoint1 == ""
          ) {
            validdata = false;
          }

          if (conditions[i].type == "Ranges") {
            if (conditions[i].setpoint2 == "") {
              validdata = false;
            }

            if (
              Number(conditions[i].setpoint2) < 0 ||
              Number(conditions[i].setpoint2) > 4294967295
            ) {
              validrange = false;
            }
          }

          if (
            Number(conditions[i].setpoint1) < 0 ||
            Number(conditions[i].setpoint1) > 4294967295
          ) {
            validrange = false;
          }
        }
        break;
      case "int64":
        for (var i = 0; i < conditions.length; i++) {
          if (
            conditions[i].type == "" ||
            conditions[i].alarmpriority == "" ||
            conditions[i].condition == "" ||
            conditions[i].setpoint1 == ""
          ) {
            validdata = false;
          }

          if (conditions[i].type == "Ranges") {
            if (conditions[i].setpoint2 == "") {
              validdata = false;
            }

            if (
              Number(conditions[i].setpoint2) < -9223372036854775808 ||
              Number(conditions[i].setpoint2) > 9223372036854775807
            ) {
              validrange = false;
            }
          }

          if (
            Number(conditions[i].setpoint1) < -9223372036854775808 ||
            Number(conditions[i].setpoint1) > 9223372036854775807
          ) {
            validrange = false;
          }
        }
        break;
      case "uint64":
        for (var i = 0; i < conditions.length; i++) {
          if (
            conditions[i].type == "" ||
            conditions[i].alarmpriority == "" ||
            conditions[i].condition == "" ||
            conditions[i].setpoint1 == ""
          ) {
            validdata = false;
          }

          if (conditions[i].type == "Ranges") {
            if (conditions[i].setpoint2 == "") {
              validdata = false;
            }

            if (
              Number(conditions[i].setpoint2) < 0 ||
              Number(conditions[i].setpoint2) > 18446744073709551615
            ) {
              validrange = false;
            }
          }

          if (
            Number(conditions[i].setpoint1) < 0 ||
            Number(conditions[i].setpoint1) > 18446744073709551615
          ) {
            validrange = false;
          }
        }
        break;
      case "float":
        for (var i = 0; i < conditions.length; i++) {
          if (
            conditions[i].type == "" ||
            conditions[i].alarmpriority == "" ||
            conditions[i].condition == "" ||
            conditions[i].setpoint1 == ""
          ) {
            validdata = false;
          }

          if (conditions[i].type == "Ranges") {
            if (conditions[i].setpoint2 == "") {
              validdata = false;
            }

            if (!isFinite(Number(conditions[i].setpoint2))) {
              validrange = false;
            }
          }

          if (!isFinite(Number(conditions[i].setpoint1))) {
            validrange = false;
          }
        }

        break;
      case "double":
        for (var i = 0; i < conditions.length; i++) {
          if (
            conditions[i].type == "" ||
            conditions[i].alarmpriority == "" ||
            conditions[i].condition == "" ||
            conditions[i].setpoint1 == ""
          ) {
            validdata = false;
          }

          if (conditions[i].type == "Ranges") {
            if (conditions[i].setpoint2 == "") {
              validdata = false;
            }

            if (!isFinite(Number(conditions[i].setpoint2))) {
              validrange = false;
            }
          }

          if (!isFinite(Number(conditions[i].setpoint1))) {
            validrange = false;
          }
        }
        break;
    }

    setConfigurationValidation({
      datavalidation: validdata,
      rangevalidation: validrange,
    });
  }

  function handleSaveChange() {
    var currentConditions = [];
    var conditionstoSave = [];
    var allconditionsfilled = true;

    for (var i = 0; i < conditions.length; i++) {
      var object = {};
      var currentconditionstoSave = {};

      if (conditions[i].condition == ">") {
        object = {
          lowerBound: conditions[i].setpoint1,
          upperBound: Infinity,
          lowerCondition: ">",
          upperCondition: "",
        };
      } else if (conditions[i].condition == ">=") {
        object = {
          lowerBound: conditions[i].setpoint1,
          upperBound: Infinity,
          lowerCondition: ">=",
          upperCondition: "",
        };
      } else if (conditions[i].condition == "<") {
        object = {
          lowerBound: -Infinity,
          upperBound: conditions[i].setpoint1,
          lowerCondition: "",
          upperCondition: "<",
        };
      } else if (conditions[i].condition == "<=") {
        object = {
          lowerBound: -Infinity,
          upperBound: conditions[i].setpoint1,
          lowerCondition: "",
          upperCondition: "<=",
        };
      } else if (conditions[i].condition == "=") {
        object = {
          lowerBound: conditions[i].setpoint1,
          upperBound: conditions[i].setpoint1,
          lowerCondition: ">=",
          upperCondition: "<=",
        };
      } else if (conditions[i].condition == ">...<") {
        object = {
          lowerBound: conditions[i].setpoint1,
          upperBound: conditions[i].setpoint2,
          lowerCondition: ">",
          upperCondition: "<",
        };
      } else if (conditions[i].condition == ">=...<=") {
        object = {
          lowerBound: conditions[i].setpoint1,
          upperBound: conditions[i].setpoint2,
          lowerCondition: ">=",
          upperCondition: "<=",
        };
      } else if (conditions[i].condition == "<...>") {
        object = {
          lowerBound: conditions[i].setpoint2,
          upperBound: conditions[i].setpoint1,
          lowerCondition: ">",
          upperCondition: "<",
        };
      } else if (conditions[i].condition == "<=...>=") {
        object = {
          lowerBound: conditions[i].setpoint2,
          upperBound: conditions[i].setpoint1,
          lowerCondition: ">=",
          upperCondition: "<=",
        };
      }

      currentconditionstoSave = {
        setpoint1: conditions[i].setpoint1,
        setpoint2: conditions[i].setpoint2,
        condition: conditions[i].condition,
        alarmpriority: conditions[i].alarmpriority,
        normalmessage: conditions[i].normalmessage,
        abnormalmessage: conditions[i].abnormalmessage,
        type: conditions[i].type,
        value: {
          alarm_condition_lower:
            object.lowerBound == -Infinity ? "-INF" : object.lowerBound,
          alarm_condition_upper:
            object.upperBound == Infinity ? "INF" : object.upperBound,
        },
      };

      //console.log("handleSaveChange-currentconditionstoSave OPERATE",currentconditionstoSave)

      if (
        conditions[i].condition == "" ||
        conditions[i].type == "" ||
        conditions[i].setpoint1 == "" ||
        conditions[i].alarmpriority == "" ||
        (conditions[i].type == "Ranges" && conditions[i].setpoint2 == "")
      ) {
        allconditionsfilled = false;
        setboolAllConditionsfilled(false);
      }
      //console.log("handleSaveChange-allconditionsfilled OPERATE",allconditionsfilled)
      currentConditions.push(object);
      conditionstoSave.push(currentconditionstoSave);
    }
    var objecttosave = {};
    //console.log("handleSaveChange-conditionstoSave OPERATE",conditionstoSave)
    var validationobject = validateConditions(conditionstoSave);

    //console.log("handleSaveChange-OPERATE-alarmrulename",alarmrulename)

    if (alarmrulename == "") {
      setAlarmRulefilled(false);
    } else {
      setAlarmRulefilled(true);
    }

    if (selectedTag.tagname == "") {
      setConfirmAlarmTagset(false);
    } else {
      setConfirmAlarmTagset(true);
    }

    if (
      configurationValidation.datavalidation == true &&
      configurationValidation.rangevalidation == true &&
      alarmrulename !== "" &&
      allconditionsfilled !== false &&
      selectedTag.tagname !== "" &&
      !existingDeviceTagAlarmConfig
    ) {
      var objecttosave = {
        id: props.uniquealarmcondition.alarmrule.id,
        Alert_rule_name: alarmrulename,
        TagID: selectedTag.TagID,
        DeviceID: tagdetailsobject[selectedTag.TagID]?.DeviceID || "DeviceID",
        enableAlert: enableAlert,
        SendMessage: sendMessage,
        SendEmail: sendEmail,
        conditions: conditionstoSave,
        createdAt: props.uniquealarmcondition.alarmrule.createdAt,
        updatedAt: new Date().toISOString(),
      };

      setObjecttosavealarmrule(objecttosave);

      const conflictingConditions = findConflictingGroups(currentConditions);

      setConflictingConditionsGroups(conflictingConditions);
      setOpen(true);
    } else {
    }

    // props.setAlarmRules(false);
  }

  const postNotificationcallback = (res) => {
    //console.log("postNotificationcallback", res);
    if (!res.success) {
      // Show error message to user, log, etc.
      console.error("Notification config failed:", res.message || res.error);
      // Optionally display a user-facing error
      return;
    }
    // Success: update UI, show success message, etc.
    //console.log("Notification config stored:", res.data);
  };

  function handleAlertEnable(event) {
    //console.log("handleAlertEnableevent.target.checked",event.target.checked)
    setenableAlert(event.target.checked);
  }

  function handleSendMessage(event) {
    setsendMessage(event.target.checked);
  }

  function handleSendEmail(event) {
    setsendEmail(event.target.checked);
  }

  function handleSaveConditions() {
    postuniquealarmconfig(
      objecttosavealarmrule,
      userdetails.Userid,
      userdetails.Projectid,
      props.uniquealarmcondition.alarmrule,
      postuniquealarmconfigcallback,
    );
    postNotification(
      {
        id: currentUserNotificationRuleId,
        TagID: selectedTag.TagID,
        NotificationGroups: checkedNodes,
        highest: enablehighestprioritynotification,
        high: enablehighprioritynotification,
        medium: enablemediumprioritynotification,
        low: enablelowprioritynotification,
      },
      postNotificationcallback,
    );
    setOpen(false);
  }

  function handleConfirmationAlarmUpdatedandSaved() {
    setopenAlarmUpdatedandSaved(false);
    props.setAlarmRulesEdit(false);
  }

  function handleCloseAlarmUpdatedandSaved() {
    setopenAlarmUpdatedandSaved(false);
    props.setAlarmRulesEdit(false);
  }

  function handleConfirmationAlarmUpdatedandSavedErr() {
    setopenAlarmUpdatedandSavedErr(false);
    props.setAlarmRulesEdit(false);
  }

  function handleCloseAlarmUpdatedandSavedErr() {
    setopenAlarmUpdatedandSavedErr(false);
    props.setAlarmRulesEdit(false);
  }

  // Handle user confirmation to delete conflicting conditions
  // const handleDeleteConflicts = () => {
  //     const currentConditionsvar = conditions.map((condition, i) => condition);

  //     const filteredConditions = currentConditionsvar.filter((_, index) => {
  //         return !conflictingconditions.some(conflict => conflict.index === index);
  //     });

  //     setConditions(filteredConditions);  // Update table with non-conflicting conditions
  //     setOpenDialog(false);  // Close dialog
  //     var objecttosave = {
  //         Alert_rule_name: props.uniquealarmcondition.alarmrule.Alert_rule_name ,
  //         device_id:props.uniquealarmcondition.alarmrule.device_id,
  //         device_name:props.uniquealarmcondition.alarmrule.device_name,
  //         selected_tag_name: {
  //             tagname: props.uniquealarmcondition.alarmrule.selected_tag_name.tagname,
  //             tagunit: props.uniquealarmcondition.alarmrule.selected_tag_name.tagunit,
  //             tagdatatype:  props.uniquealarmcondition.alarmrule.TagDataType,
  //             std_tagname: props.uniquealarmcondition.alarmrule.selected_tag_name.std_tagname
  //         },
  //         conditions:acceptconditions,
  //         createdAt: new Date().toISOString(),
  //         updatedAt: new Date().toISOString(),
  //     }
  //     var mergedobject = { ...props.uniquealarmcondition.alarmrule, ...objecttosave }
  //     console.log("mergedobject in AlarmRulesConfig-mergedobject",mergedobject)
  //     postuniquealarmconfig(mergedobject,postuniquealarmconfigcallback);
  //     alert('Conflicting conditions removed and saved successfully.');
  // };

  function linearSearch(arr, target) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === target) {
        return i;
      }
    }
    return -1;
  }

  function handleAlarmRuleName(event) {
    setAlarmRuleName(event.target.value);
  }

  function handlePriorityCheck(event, priority) {
    if (priority == "Highest") {
      setenablehighestprioritynotification((prevstate) => !prevstate);
    } else if (priority == "High") {
      setenablehighprioritynotification((prevstate) => !prevstate);
    } else if (priority == "Medium") {
      setenablemediumprioritynotification((prevstate) => !prevstate);
    } else if (priority == "Low") {
      setenablelowprioritynotification((prevstate) => !prevstate);
    }
  }

  const handleCheck = (event, node, nodeId, devicename, deviceId) => {
    // Add or remove the selected node object based on its current state
    setCheckedNodes((prevCheckedNodes) => {
      const isNodeSelected = prevCheckedNodes.some(
        (checkedNode) => checkedNode?.id === nodeId,
      );

      if (isNodeSelected) {
        // If the node is already checked, remove it from the array
        return prevCheckedNodes.filter(
          (checkedNode) => checkedNode?.id !== nodeId,
        );
      } else {
        // If the node is not checked, add it to the array
        return [...prevCheckedNodes, { ...node }];
      }
    });
  };

  return (
    <>
      {/* console.log("conditions////////---------------",conditions) */}
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex", marginTop: 0, paddingTop: 0 }}>
          <div style={{ flexGrow: 1 }}></div>
          {existingDeviceTagAlarmConfig == true && (
            <Typography
              sx={{
                marginRight: "20px",
                marginTop: "5px",
                fontSize: "16px",
                fontFamily: "Roboto",
                color: "#DC272D",
                fontWeight: 400,
                marginLeft: "14px",
                textAlign: "left",
                marginLeft: "10px",
                marginTop: "10px",
              }}
            >
              Existing Alarm Rule created for this device and tag
            </Typography>
          )}
          {alarmrulefilled == false && (
            <Typography
              sx={{
                marginRight: "20px",
                marginTop: "5px",
                fontSize: "16px",
                fontFamily: "Roboto",
                color: "#DC272D",
                fontWeight: 400,
                marginLeft: "14px",
                textAlign: "left",
                marginLeft: "10px",
                marginTop: "10px",
              }}
            >
              Please enter alarm rule name
            </Typography>
          )}
          {configurationValidation.datavalidation == false && (
            <Typography
              sx={{
                marginRight: "20px",
                marginTop: "5px",
                fontSize: "16px",
                fontFamily: "Roboto",
                color: "#DC272D",
                fontWeight: 400,
                marginLeft: "14px",
                textAlign: "left",
                marginLeft: "10px",
                marginTop: "10px",
              }}
            >
              Please complete all fields
            </Typography>
          )}
          {configurationValidation.rangevalidation == false && (
            <Typography
              sx={{
                marginRight: "20px",
                marginTop: "5px",
                fontSize: "16px",
                fontFamily: "Roboto",
                color: "#DC272D",
                fontWeight: 400,
                marginLeft: "14px",
                textAlign: "left",
                marginLeft: "10px",
                marginTop: "10px",
              }}
            >
              Please enter data setpoint within range limit of tag data type
            </Typography>
          )}
          {confirmAlarmTagset == false && (
            <Typography
              sx={{
                marginRight: "20px",
                marginTop: "5px",
                fontSize: "16px",
                fontFamily: "Roboto",
                color: "#DC272D",
                fontWeight: 400,
                marginLeft: "14px",
                textAlign: "left",
                marginLeft: "10px",
                marginTop: "10px",
              }}
            >
              Select Tag from Device
            </Typography>
          )}
          <div style={{ marginTop: "10px", marginRight: "5px" }}>
            <CustomCancelButton
              margin="10px 10px 0px 0px"
              onClick={handleCancelChange}
              buttonText={"Cancel"}
            ></CustomCancelButton>
          </div>
          <Button
            sx={{
              outline: "none !important",
              boxShadow: "none",
              height: "35px",
              width: "100px",
              fontSize: "16px",
              textTransform: "capitalize",
              marginTop: "10px",
              marginRight: "5px",
              backgroundColor: "#005C8E",
              borderRadius: "20px",
            }}
            variant="contained"
            onClick={handleSaveChange}
          >
            Save
          </Button>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ width: "20%" }}>
            <Typography
              sx={{
                fontSize: "16px",
                fontFamily: "Roboto",
                color: "var(--SecondaryText)",
                fontWeight: 400,
                marginLeft: "14px",
                marginTop: "6px",
                textAlign: "left",
              }}
            >
              Rule Name
              <span style={{ color: "#DC272D", marginLeft: "5px" }}>*</span>
            </Typography>
            <Box style={{ textAlign: "left", paddingTop: "0px" }}>
              {" "}
              {/* Changing rule name is not enabled yet */}
              <TextField
                required
                className="textfield"
                sx={{
                  marginLeft: "16px",
                  marginTop: "0px",
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  marginLeft: "14px",
                  "& .MuiInputBase-input:focus": {
                    color: "#008CD7",
                  },
                  "& .MuiInputBase-root": {
                    fontFamily: "Roboto",
                    fontSize: "16px",
                    fontWeight: "700",
                    color: themechange === "light" ? "#3C3C3C" : "#FFFFFF",
                  },
                  "& .MuiInputBase-input.Mui-disabled": {
                    color: themechange === "light" ? "#3C3C3C" : "#FFFFFF", // Default color
                    WebkitTextFillColor:
                      themechange === "light" ? "#3C3C3C" : "#FFFFFF", // Default color
                  },
                  "& .MuiInputBase-root::before": {
                    borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottom: "2px solid #008CD7",
                  },
                  "& .MuiInputBase-root::after": {
                    borderBottom: "2px solid #008CD7",
                  },
                }}
                disabled={
                  !props.uniquealarmcondition.alarmrule.Alert_rule_name.includes(
                    "clone",
                  )
                }
                label=""
                value={alarmrulename}
                variant="standard"
                onChange={handleAlarmRuleName}
              />
            </Box>

            <div>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  color: "var(--SecondaryText)",
                  fontWeight: 400,
                  marginLeft: "14px",
                  textAlign: "left",
                  marginTop: "25px",
                  marginBottom: "10px",
                }}
              >
                Selected Tagname:
                {selectedAsset.asset_name +
                  ": " +
                  selectedTag.tagname +
                  "    " +
                  selectedTag.tagunit}
                <span style={{ color: "#DC272D", marginLeft: "5px" }}>*</span>
              </Typography>
              {/* Div enclosing asset tag retrieval is not included yet */}
            </div>
            {props.uniquealarmcondition.alarmrule.Alert_rule_name.includes(
              "clone",
            ) && (
              <div>
                <div>
                  <AssetTagsRetrieval
                    assetdata={assetdata}
                    assetdataerror={assetdataerror}
                    setExistingDeviceTagAlarmConfig={
                      setExistingDeviceTagAlarmConfig
                    }
                    setSelectedTag={setSelectedTag}
                    setSelectedAsset={setSelectedAsset}
                  />
                </div>
              </div>
            )}
          </div>
          <div style={{ width: "80%", marginLeft: "25px" }}>
            <div>
              {/* Table for entering conditions */}
              {/*TAGDATATYPE COMMENT console.log("props.uniquealarmcondition.alarmrule.TagDataType",props.uniquealarmcondition.alarmrule.TagDataType) */
              /*TAGDATATYPE COMMENT] {((((props.uniquealarmcondition.alarmrule.TagDataType !== 'bool') && !(props.uniquealarmcondition.alarmrule.Alert_rule_name.includes('clone'))) || ((selectedTag.tagdatatype !== 'bool') && (props.uniquealarmcondition.alarmrule.Alert_rule_name.includes('clone')))) &&*/}
              {((props.uniquealarmcondition.alarmrule.TagDataType != "bool" &&
                !props.uniquealarmcondition.alarmrule.Alert_rule_name.includes(
                  "clone",
                )) ||
                (selectedTag.tagdatatype != "bool" &&
                  props.uniquealarmcondition.alarmrule.Alert_rule_name.includes(
                    "clone",
                  ))) && (
                <>
                  <div style={{ overflowY: "auto", padding: "20px" }}>
                    <TableContainer
                      component={Paper}
                      sx={{
                        width: "100%",
                        paddingLeft: "0px",
                        backgroundColor: "var(--secondary-backgroundLK)",
                        paddingRight: "0px",
                        height: `calc(100vh - ${pagesize}px)-200px`,
                      }}
                      className="styled-scrollbar"
                      elevation={0}
                    >
                      <Table stickyHeader sx={{ width: "100%" }} size="large">
                        <TableHead sx={{ width: "100%" }}>
                          <TableRow sx={{ border: "0px" }}>
                            <TableCell
                              align="left"
                              sx={{
                                backgroundColor:
                                  "var(--secondary-backgroundLK)",
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <CustomTableHeading children={"Type"} />
                                <span
                                  style={{
                                    color: "#DC272D",
                                    marginLeft: "5px",
                                  }}
                                >
                                  *
                                </span>
                              </div>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                backgroundColor:
                                  "var(--secondary-backgroundLK)",
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <CustomTableHeading children={"Condition"} />
                                <span
                                  style={{
                                    color: "#DC272D",
                                    marginLeft: "5px",
                                  }}
                                >
                                  *
                                </span>
                              </div>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                backgroundColor:
                                  "var(--secondary-backgroundLK)",
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <CustomTableHeading children={"Setpoint1"} />
                                <span
                                  style={{
                                    color: "#DC272D",
                                    marginLeft: "5px",
                                  }}
                                >
                                  *
                                </span>
                              </div>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                backgroundColor:
                                  "var(--secondary-backgroundLK)",
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <CustomTableHeading children={"Setpoint2"} />
                                <span
                                  style={{
                                    color: "#DC272D",
                                    marginLeft: "5px",
                                  }}
                                >
                                  *
                                </span>
                              </div>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                backgroundColor:
                                  "var(--secondary-backgroundLK)",
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <CustomTableHeading
                                  children={"Alarm Priority"}
                                />
                                <span
                                  style={{
                                    color: "#DC272D",
                                    marginLeft: "5px",
                                  }}
                                >
                                  *
                                </span>
                              </div>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                backgroundColor:
                                  "var(--secondary-backgroundLK)",
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading
                                children={"Abnormal Message"}
                              />
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                backgroundColor:
                                  "var(--secondary-backgroundLK)",
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading children={"Normal Message"} />
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                backgroundColor:
                                  "var(--secondary-backgroundLK)",
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading children={"Delete"} />
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                backgroundColor:
                                  "var(--secondary-backgroundLK)",
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading children={"Add"} />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {conditions &&
                            conditions.map((condition, index) => {
                              if (
                                condition &&
                                condition.hasOwnProperty("type") &&
                                condition.hasOwnProperty("condition") &&
                                condition.hasOwnProperty("setpoint1") &&
                                condition.hasOwnProperty("setpoint2") &&
                                condition.hasOwnProperty("alarmpriority") &&
                                condition.hasOwnProperty("normalmessage") &&
                                condition.hasOwnProperty("abnormalmessage")
                              ) {
                                return (
                                  <TableRow
                                    key={index}
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                      height: "9px",
                                      "& > *": {
                                        borderBottom:
                                          "1px solid var(--table-boarder-line)",
                                      },
                                    }}
                                  >
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <FormControl
                                        variant="standard"
                                        sx={{ marginTop: "0px", minWidth: 50 }}
                                      >
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          IconComponent={KeyboardArrowDownIcon}
                                          sx={{
                                            "&:before": {
                                              borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                            },
                                            "&:hover:not(.Mui-disabled):before":
                                              {
                                                borderBottom:
                                                  "2px solid #008CD7",
                                              },
                                            "&:after": {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                            margin: 0,
                                            padding: 0,
                                            width: "100px",
                                            fontSize: "18px",
                                            fontFamily: "Roboto",
                                            fontWeight: "700 !important",
                                            color: "var(--PrimaryText)",
                                            "& .MuiInputBase-input": {
                                              paddingLeft: 0,
                                            },
                                            "& .MuiInputBase-input:focus": {
                                              color:
                                                "var(--HighlightedText_Stroke)",
                                              borderBottom:
                                                "2px solid var(--HighlightedText_Stroke)",
                                              backgroundColor: "transparent",
                                              fontWeight: "700 !important",
                                              "& .MuiSvgIcon-root": {
                                                color:
                                                  "var(--HighlightedText_Stroke) !important",
                                              },
                                            },
                                            "& .MuiInputBase-input:focus .MuiSvgIcon-root":
                                              {
                                                color:
                                                  "var(--HighlightedText_Stroke)", //not working
                                              },
                                            "& .MuiSvgIcon-root": {
                                              color: "var(--PrimaryText)",
                                            },
                                            "& .MuiNativeSelect-select": {
                                              paddingTop: 0,
                                              paddingBottom: 0,
                                            },
                                            "& .MuiNativeSelect-select option":
                                              {
                                                backgroundColor:
                                                  "var(--dropdown-bg) !important",
                                                fontSize: "18px",
                                                fontFamily: "Roboto",
                                                fontWeight: 400,
                                                color:
                                                  "var(--PrimaryText) !important",
                                                borderBottom:
                                                  "2px solid var(--HighlightedText_Stroke)", //not working
                                              },
                                            "& .MuiNativeSelect-select option:checked":
                                              {
                                                backgroundColor:
                                                  "var(--dropdown-bg) !important",
                                                color:
                                                  "var(--White) !important",
                                                fontWeight: "700 !important",
                                                borderColor:
                                                  "2px solid var(--HighlightedText_Stroke)",
                                              },
                                            "& .MuiInputBase-input option:hover":
                                              {
                                                backgroundColor:
                                                  "#005D8F !important",
                                              },
                                          }}
                                          MenuProps={{
                                            PaperProps: {
                                              sx: {
                                                width: "100px",
                                                bgcolor:
                                                  themechange === "dark"
                                                    ? "#3C3C3C"
                                                    : "#C1C1C1",
                                                borderBottom:
                                                  "2px solid #008CD7",
                                                borderRadius: 0,
                                                boxShadow: "none",
                                                maxHeight: "250px",
                                                overflow: "auto",
                                                color:
                                                  themechange === "dark"
                                                    ? "#FFFFFF"
                                                    : "#3C3C3C",
                                              },
                                            },
                                          }}
                                          label=""
                                          value={condition.type}
                                          /* disabled={(selectedTag.tagname=='' && selectedTag.tagunit=='')} */
                                          onChange={(e) =>
                                            handleConditionChange(
                                              index,
                                              "type",
                                              e.target.value,
                                            )
                                          }
                                        >
                                          <MenuItem
                                            sx={{ paddingLeft: 1 }}
                                            value={"Conditional"}
                                          >
                                            {"Conditional"}
                                          </MenuItem>
                                          <MenuItem
                                            sx={{ paddingLeft: 1 }}
                                            value={"Equal"}
                                          >
                                            {"Equal"}
                                          </MenuItem>
                                          <MenuItem
                                            sx={{ paddingLeft: 1 }}
                                            value={"Ranges"}
                                          >
                                            {"Ranges"}
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <FormControl
                                        variant="standard"
                                        sx={{ marginTop: "0px", minWidth: 50 }}
                                      >
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          IconComponent={KeyboardArrowDownIcon}
                                          sx={{
                                            "&:before": {
                                              borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                            },
                                            "&:hover:not(.Mui-disabled):before":
                                              {
                                                borderBottom:
                                                  "2px solid #008CD7",
                                              },
                                            "&:after": {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                            margin: 0,
                                            padding: 0,
                                            width: "100px",
                                            fontSize: "18px",
                                            fontFamily: "Roboto",
                                            fontWeight: "700 !important",
                                            color: "var(--PrimaryText)",
                                            "& .MuiInputBase-input": {
                                              paddingLeft: 0,
                                            },
                                            "& .MuiInputBase-input:focus": {
                                              color:
                                                "var(--HighlightedText_Stroke)",
                                              borderBottom:
                                                "2px solid var(--HighlightedText_Stroke)",
                                              backgroundColor: "transparent",
                                              fontWeight: "700 !important",
                                              "& .MuiSvgIcon-root": {
                                                color:
                                                  "var(--HighlightedText_Stroke) !important",
                                              },
                                            },
                                            "& .MuiInputBase-input:focus .MuiSvgIcon-root":
                                              {
                                                color:
                                                  "var(--HighlightedText_Stroke)", //not working
                                              },
                                            "& .MuiSvgIcon-root": {
                                              color: "var(--PrimaryText)",
                                            },
                                            "& .MuiNativeSelect-select": {
                                              paddingTop: 0,
                                              paddingBottom: 0,
                                            },
                                            "& .MuiNativeSelect-select option":
                                              {
                                                backgroundColor:
                                                  "var(--dropdown-bg) !important",
                                                fontSize: "18px",
                                                fontFamily: "Roboto",
                                                fontWeight: 400,
                                                color:
                                                  "var(--PrimaryText) !important",
                                                borderBottom:
                                                  "2px solid var(--HighlightedText_Stroke)", //not working
                                              },
                                            "& .MuiNativeSelect-select option:checked":
                                              {
                                                backgroundColor:
                                                  "var(--dropdown-bg) !important",
                                                color:
                                                  "var(--White) !important",
                                                fontWeight: "700 !important",
                                                borderColor:
                                                  "2px solid var(--HighlightedText_Stroke)",
                                              },
                                            "& .MuiInputBase-input option:hover":
                                              {
                                                backgroundColor:
                                                  "#005D8F !important",
                                              },
                                          }}
                                          MenuProps={{
                                            PaperProps: {
                                              sx: {
                                                width: "100px",
                                                bgcolor:
                                                  themechange === "dark"
                                                    ? "#3C3C3C"
                                                    : "#C1C1C1",
                                                borderBottom:
                                                  "2px solid #008CD7",
                                                borderRadius: 0,
                                                boxShadow: "none",
                                                maxHeight: "250px",
                                                overflow: "auto",
                                                color:
                                                  themechange === "dark"
                                                    ? "#FFFFFF"
                                                    : "#3C3C3C",
                                              },
                                            },
                                          }}
                                          label=""
                                          value={condition.condition}
                                          /* disabled={(selectedTag.tagname=='' && selectedTag.tagunit=='')} */
                                          onChange={(e) =>
                                            handleConditionChange(
                                              index,
                                              "condition",
                                              e.target.value,
                                            )
                                          }
                                        >
                                          {condition.type == "Conditional" && (
                                            <MenuItem
                                              sx={{ paddingLeft: 1 }}
                                              value={"<="}
                                            >
                                              {"<="}
                                            </MenuItem>
                                          )}
                                          {/* <MenuItem sx={{paddingLeft:1}} value={"="}>{"="}</MenuItem> */}
                                          {condition.type == "Conditional" && (
                                            <MenuItem
                                              sx={{ paddingLeft: 1 }}
                                              value={">="}
                                            >
                                              {">="}
                                            </MenuItem>
                                          )}
                                          {condition.type == "Conditional" && (
                                            <MenuItem
                                              sx={{ paddingLeft: 1 }}
                                              value={"<"}
                                            >
                                              {"<"}
                                            </MenuItem>
                                          )}
                                          {condition.type == "Conditional" && (
                                            <MenuItem
                                              sx={{ paddingLeft: 1 }}
                                              value={">"}
                                            >
                                              {">"}
                                            </MenuItem>
                                          )}
                                          {condition.type == "Equal" && (
                                            <MenuItem
                                              sx={{ paddingLeft: 1 }}
                                              value={"="}
                                            >
                                              {"="}
                                            </MenuItem>
                                          )}
                                          {condition.type == "Ranges" && (
                                            <MenuItem
                                              sx={{ paddingLeft: 1 }}
                                              value={">...<"}
                                            >
                                              {">...<"}
                                            </MenuItem>
                                          )}
                                          {condition.type == "Ranges" && (
                                            <MenuItem
                                              sx={{ paddingLeft: 1 }}
                                              value={">=...<="}
                                            >
                                              {">=...<="}
                                            </MenuItem>
                                          )}
                                          {condition.type == "Ranges" && (
                                            <MenuItem
                                              sx={{ paddingLeft: 1 }}
                                              value={"<...>"}
                                            >
                                              {"<...>"}
                                            </MenuItem>
                                          )}
                                          {condition.type == "Ranges" && (
                                            <MenuItem
                                              sx={{ paddingLeft: 1 }}
                                              value={"<=...>="}
                                            >
                                              {"<=...>="}
                                            </MenuItem>
                                          )}
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      {/* <Box className="config-form-box" >
                                                                        <Typography  style={{ fontSize: '18px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Name</Typography>
                                                                        <CustomTextField id={'negative-feedback'} selected={handleGatewayName} defaultValue={gatewayno[props.index].data.GatewayName} width={224}/> 
                                                                    </Box>*/}
                                      <TextField
                                        label=""
                                        value={condition?.setpoint1}
                                        variant="standard"
                                        type="number"
                                        onChange={(e) =>
                                          handleConditionChange(
                                            index,
                                            "setpoint1",
                                            e.target.value,
                                          )
                                        }
                                        sx={{
                                          width: "94px",
                                          "& .MuiInputBase-input:focus": {
                                            color: "#008CD7",
                                          },
                                          "& .MuiInputBase-root": {
                                            fontFamily: "Roboto",
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            color:
                                              themechange === "light"
                                                ? "#3C3C3C"
                                                : "#FFFFFF",
                                          },
                                          "& .MuiInput-root .MuiInputBase-input":
                                            {},
                                          "& .MuiInputBase-root::before": {
                                            borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                          },
                                          "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                            {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                          "& .MuiInputBase-root::after": {
                                            borderBottom: "2px solid #008CD7",
                                          },
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      {/* <Box className="config-form-box" >
                                                                        <Typography  style={{ fontSize: '18px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Name</Typography>
                                                                        <CustomTextField id={'negative-feedback'} selected={handleGatewayName} defaultValue={gatewayno[props.index].data.GatewayName} width={224}/> 
                                                                    </Box>*/}
                                      <TextField
                                        label=""
                                        value={condition?.setpoint2}
                                        variant="standard"
                                        type="number"
                                        onChange={(e) =>
                                          handleConditionChange(
                                            index,
                                            "setpoint2",
                                            e.target.value,
                                          )
                                        }
                                        disabled={condition.type != "Ranges"}
                                        sx={{
                                          width: "94px",
                                          "& .MuiInputBase-input:focus": {
                                            color: "#008CD7",
                                          },
                                          "& .MuiInputBase-root": {
                                            fontFamily: "Roboto",
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            color:
                                              themechange === "light"
                                                ? "#3C3C3C"
                                                : "#FFFFFF",
                                          },
                                          "& .MuiInput-root .MuiInputBase-input":
                                            {},
                                          "& .MuiInputBase-root::before": {
                                            borderBottom:
                                              condition.type == "Ranges"
                                                ? `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`
                                                : `1px dotted ${"#7E7E7E"}`,
                                          },
                                          "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                            {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                          "& .MuiInputBase-root::after": {
                                            borderBottom: "2px solid #008CD7",
                                          },
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <FormControl
                                        variant="standard"
                                        sx={{ marginTop: "0px", minWidth: 120 }}
                                      >
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          IconComponent={KeyboardArrowDownIcon}
                                          sx={{
                                            "&:before": {
                                              borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                            },
                                            "&:hover:not(.Mui-disabled):before":
                                              {
                                                borderBottom:
                                                  "2px solid #008CD7",
                                              },
                                            "&:after": {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                            margin: 0,
                                            padding: 0,
                                            width: "193px",
                                            fontSize: "18px",
                                            fontFamily: "Roboto",
                                            fontWeight: "700 !important",
                                            color: "var(--PrimaryText)",
                                            "& .MuiInputBase-input": {
                                              paddingLeft: 0,
                                            },
                                            "& .MuiInputBase-input:focus": {
                                              color:
                                                "var(--HighlightedText_Stroke)",
                                              borderBottom:
                                                "2px solid var(--HighlightedText_Stroke)",
                                              backgroundColor: "transparent",
                                              fontWeight: "700 !important",
                                              "& .MuiSvgIcon-root": {
                                                color:
                                                  "var(--HighlightedText_Stroke) !important",
                                              },
                                            },
                                            "& .MuiInputBase-input:focus .MuiSvgIcon-root":
                                              {
                                                color:
                                                  "var(--HighlightedText_Stroke)", //not working
                                              },
                                            "& .MuiSvgIcon-root": {
                                              color: "var(--PrimaryText)",
                                            },
                                            "& .MuiNativeSelect-select": {
                                              paddingTop: 0,
                                              paddingBottom: 0,
                                            },
                                            "& .MuiNativeSelect-select option":
                                              {
                                                backgroundColor:
                                                  "var(--dropdown-bg) !important",
                                                fontSize: "18px",
                                                fontFamily: "Roboto",
                                                fontWeight: 400,
                                                color:
                                                  "var(--PrimaryText) !important",
                                                borderBottom:
                                                  "2px solid var(--HighlightedText_Stroke)", //not working
                                              },
                                            "& .MuiNativeSelect-select option:checked":
                                              {
                                                backgroundColor:
                                                  "var(--dropdown-bg) !important",
                                                color:
                                                  "var(--White) !important",
                                                fontWeight: "700 !important",
                                                borderColor:
                                                  "2px solid var(--HighlightedText_Stroke)",
                                              },
                                            "& .MuiInputBase-input option:hover":
                                              {
                                                backgroundColor:
                                                  "#005D8F !important",
                                              },
                                          }}
                                          MenuProps={{
                                            PaperProps: {
                                              sx: {
                                                width: "40px",
                                                bgcolor:
                                                  themechange === "dark"
                                                    ? "#3C3C3C"
                                                    : "#C1C1C1",
                                                borderBottom:
                                                  "2px solid #008CD7",
                                                borderRadius: 0,
                                                boxShadow: "none",
                                                maxHeight: "250px",
                                                overflow: "auto",
                                                color:
                                                  themechange === "dark"
                                                    ? "#FFFFFF"
                                                    : "#3C3C3C",
                                              },
                                            },
                                          }}
                                          onChange={(e) =>
                                            handleConditionChange(
                                              index,
                                              "alarmpriority",
                                              e.target.value,
                                            )
                                          }
                                          label="Alarm Priority"
                                          value={condition.alarmpriority}
                                        >
                                          <MenuItem value={"Highest"}>
                                            {"Highest"}
                                          </MenuItem>
                                          <MenuItem value={"High"}>
                                            {"High"}
                                          </MenuItem>
                                          <MenuItem value={"Medium"}>
                                            {"Medium"}
                                          </MenuItem>
                                          <MenuItem value={"Low"}>
                                            {"Low"}
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <TextField
                                        label=""
                                        value={condition.abnormalmessage}
                                        variant="standard"
                                        sx={{
                                          width: "94px",
                                          "& .MuiInputBase-input:focus": {
                                            color: "#008CD7",
                                          },
                                          "& .MuiInputBase-root": {
                                            fontFamily: "Roboto",
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            color:
                                              themechange === "light"
                                                ? "#3C3C3C"
                                                : "#FFFFFF",
                                          },
                                          "& .MuiInput-root .MuiInputBase-input":
                                            {},
                                          "& .MuiInputBase-root::before": {
                                            borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                          },
                                          "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                            {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                          "& .MuiInputBase-root::after": {
                                            borderBottom: "2px solid #008CD7",
                                          },
                                        }}
                                        onChange={(e) =>
                                          handleConditionChange(
                                            index,
                                            "abnormalmessage",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <TextField
                                        label=""
                                        value={condition.normalmessage}
                                        variant="standard"
                                        sx={{
                                          width: "94px",
                                          "& .MuiInputBase-input:focus": {
                                            color: "#008CD7",
                                          },
                                          "& .MuiInputBase-root": {
                                            fontFamily: "Roboto",
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            color:
                                              themechange === "light"
                                                ? "#3C3C3C"
                                                : "#FFFFFF",
                                          },
                                          "& .MuiInput-root .MuiInputBase-input":
                                            {},
                                          "& .MuiInputBase-root::before": {
                                            borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                          },
                                          "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                            {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                          "& .MuiInputBase-root::after": {
                                            borderBottom: "2px solid #008CD7",
                                          },
                                        }}
                                        onChange={(e) =>
                                          handleConditionChange(
                                            index,
                                            "normalmessage",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "2px",
                                        paddingBottom: "2px",
                                      }}
                                    >
                                      <Button
                                        sx={{
                                          width: "20px",
                                          height: "20px",
                                          padding: "0px",
                                          fontSize: "16px",
                                          fontFamily: "Roboto",
                                          textTransform: "capitalize",
                                          backgroundColor:
                                            "var(--SecondaryBackground)",
                                          borderRadius: "20px",
                                          boxShadow: "none",
                                        }}
                                        variant="text"
                                        onClick={() => handleRemoveRow(index)}
                                        disableTouchRipple
                                        elevation={0}
                                      >
                                        <LK_Delete
                                          color={"#005C8E"}
                                          width={"20px"}
                                          height={"20px"}
                                        />
                                      </Button>
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        alignItems: "baseline",
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "2px",
                                        paddingBottom: "2px",
                                      }}
                                    >
                                      {
                                        <div
                                          style={{
                                            display: "flex",
                                            marginTop: 0,
                                            paddingTop: 0,
                                          }}
                                        >
                                          <CustomActionButton
                                            buttonText={"Add Row"}
                                            onClick={handleAddRow}
                                          />
                                        </div>
                                      }
                                    </TableCell>
                                  </TableRow>
                                );
                              } else {
                                console.error(
                                  "Invalid condition object:",
                                  condition,
                                );
                                return null; // Skip rendering invalid rows
                              }
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                  {/* <div style={{display:"flex", marginTop:0, paddingTop:0}}>
                                            <div style={{flexGrow: 1}}></div>
                                            <Button sx={{textTransform:'capitalize', marginTop:"5px", marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px", width:"187px", marginRight:"15px",marginBottom:"15px",marginTop:"15px"}} variant="contained" onClick={handleAddRow}>
                                                Add Condition
                                            </Button>
                                        </div> */}

                  {/*  <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                                        <DialogTitle>Overlapping Conditions Detected</DialogTitle>
                                        <DialogContent>
                                            {conflictingconditions.map((conflict, index) => (
                                                <Typography key={index}>
                                                    Conflict for Condition {conflict.condition} with setpoint {conflict.setpoint}
                                                </Typography>
                                            ))}
                                            <Typography>Do you want to remove these conflicting conditions?</Typography>
                                        </DialogContent>
                                        <DialogActions>
                                        <Button onClick={handleDeleteConflicts} color="primary">
                                            Yes, Delete Conflicts
                                        </Button>
                                        <Button onClick={() => setOpenDialog(false)} color="secondary">
                                            No, I'll Edit Manually
                                        </Button>
                                        </DialogActions>
                                    </Dialog>
                                    */}
                </>
              )}
              {/* TAGDATATYPE COMMENT- { ((((props.uniquealarmcondition.alarmrule.TagDataType === 'bool') && !(props.uniquealarmcondition.alarmrule.Alert_rule_name.includes('clone'))) || ((selectedTag.tagdatatype === 'bool') && (props.uniquealarmcondition.alarmrule.Alert_rule_name.includes('clone')))) &&*/}
              {((props.uniquealarmcondition.alarmrule.TagDataType === "bool" &&
                !props.uniquealarmcondition.alarmrule.Alert_rule_name.includes(
                  "clone",
                )) ||
                (selectedTag.tagdatatype === "bool" &&
                  props.uniquealarmcondition.alarmrule.Alert_rule_name.includes(
                    "clone",
                  ))) && (
                <>
                  <div style={{ overflowY: "auto", padding: "20px" }}>
                    <TableContainer
                      component={Paper}
                      sx={{
                        width: "100%",
                        paddingLeft: "0px",
                        backgroundColor: "var(--secondary-backgroundLK)",
                        paddingRight: "0px",
                        height: `calc(100vh - ${pagesize}px)-200px`,
                      }}
                      className="styled-scrollbar"
                      elevation={0}
                    >
                      <Table stickyHeader sx={{ width: "100%" }} size="large">
                        <TableHead sx={{ width: "100%" }}>
                          <TableRow sx={{ border: "0px" }}>
                            <TableCell
                              align="left"
                              sx={{
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading children={"Type"} />
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading children={"Condition"} />
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading children={"Setpoint1"} />
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading children={"Setpoint2"} />
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading children={"Alert Priority"} />
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading
                                children={"Abnormal Message"}
                              />
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading children={"Normal Message"} />
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading children={"Delete"} />
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                padding: "0px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "var(--grey-variation-tableLK)",
                              }}
                            >
                              <CustomTableHeading children={"Add"} />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {conditions &&
                            conditions.map((condition, index) => {
                              if (
                                condition &&
                                condition.hasOwnProperty("type") &&
                                condition.hasOwnProperty("condition") &&
                                condition.hasOwnProperty("setpoint1") &&
                                condition.hasOwnProperty("setpoint2") &&
                                condition.hasOwnProperty("alarmpriority") &&
                                condition.hasOwnProperty("normalmessage") &&
                                condition.hasOwnProperty("abnormalmessage")
                              ) {
                                return (
                                  <TableRow
                                    key={index}
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                      height: "9px",
                                      "& > *": {
                                        borderBottom:
                                          "1px solid var(--table-boarder-line)",
                                      },
                                    }}
                                  >
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <FormControl
                                        variant="standard"
                                        sx={{ marginTop: "0px", minWidth: 50 }}
                                      >
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          IconComponent={KeyboardArrowDownIcon}
                                          sx={{
                                            "&:before": {
                                              borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                            },
                                            "&:hover:not(.Mui-disabled):before":
                                              {
                                                borderBottom:
                                                  "2px solid #008CD7",
                                              },
                                            "&:after": {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                            margin: 0,
                                            padding: 0,
                                            width: "100px",
                                            fontSize: "18px",
                                            fontFamily: "Roboto",
                                            fontWeight: "700 !important",
                                            color: "var(--PrimaryText)",
                                            "& .MuiInputBase-input": {
                                              paddingLeft: 0,
                                            },
                                            "& .MuiInputBase-input:focus": {
                                              color:
                                                "var(--HighlightedText_Stroke)",
                                              borderBottom:
                                                "2px solid var(--HighlightedText_Stroke)",
                                              backgroundColor: "transparent",
                                              fontWeight: "700 !important",
                                              "& .MuiSvgIcon-root": {
                                                color:
                                                  "var(--HighlightedText_Stroke) !important",
                                              },
                                            },
                                            "& .MuiInputBase-input:focus .MuiSvgIcon-root":
                                              {
                                                color:
                                                  "var(--HighlightedText_Stroke)", //not working
                                              },
                                            "& .MuiSvgIcon-root": {
                                              color: "var(--PrimaryText)",
                                            },
                                            "& .MuiNativeSelect-select": {
                                              paddingTop: 0,
                                              paddingBottom: 0,
                                            },
                                            "& .MuiNativeSelect-select option":
                                              {
                                                backgroundColor:
                                                  "var(--dropdown-bg) !important",
                                                fontSize: "18px",
                                                fontFamily: "Roboto",
                                                fontWeight: 400,
                                                color:
                                                  "var(--PrimaryText) !important",
                                                borderBottom:
                                                  "2px solid var(--HighlightedText_Stroke)", //not working
                                              },
                                            "& .MuiNativeSelect-select option:checked":
                                              {
                                                backgroundColor:
                                                  "var(--dropdown-bg) !important",
                                                color:
                                                  "var(--White) !important",
                                                fontWeight: "700 !important",
                                                borderColor:
                                                  "2px solid var(--HighlightedText_Stroke)",
                                              },
                                            "& .MuiInputBase-input option:hover":
                                              {
                                                backgroundColor:
                                                  "#005D8F !important",
                                              },
                                          }}
                                          MenuProps={{
                                            PaperProps: {
                                              sx: {
                                                width: "100px",
                                                bgcolor:
                                                  themechange === "dark"
                                                    ? "#3C3C3C"
                                                    : "#C1C1C1",
                                                borderBottom:
                                                  "2px solid #008CD7",
                                                borderRadius: 0,
                                                boxShadow: "none",
                                                maxHeight: "250px",
                                                overflow: "auto",
                                                color:
                                                  themechange === "dark"
                                                    ? "#FFFFFF"
                                                    : "#3C3C3C",
                                              },
                                            },
                                          }}
                                          label=""
                                          value={condition.type}
                                          disabled={
                                            selectedTag.tagname == "" &&
                                            selectedTag.tagunit == ""
                                          }
                                          onChange={(e) =>
                                            handleConditionChange(
                                              index,
                                              "type",
                                              e.target.value,
                                            )
                                          }
                                        >
                                          <MenuItem
                                            sx={{ paddingLeft: 1 }}
                                            value={"True"}
                                          >
                                            {"True"}
                                          </MenuItem>
                                          <MenuItem
                                            sx={{ paddingLeft: 1 }}
                                            value={"False"}
                                          >
                                            {"False"}
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <FormControl
                                        variant="standard"
                                        sx={{ marginTop: "0px", minWidth: 50 }}
                                      >
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          IconComponent={KeyboardArrowDownIcon}
                                          sx={{
                                            "&:before": {
                                              borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                            },
                                            "&:hover:not(.Mui-disabled):before":
                                              {
                                                borderBottom:
                                                  "2px solid #008CD7",
                                              },
                                            "&:after": {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                            margin: 0,
                                            padding: 0,
                                            width: "100px",
                                            fontSize: "18px",
                                            fontFamily: "Roboto",
                                            fontWeight: "700 !important",
                                            color: "var(--PrimaryText)",
                                            "& .MuiInputBase-input": {
                                              paddingLeft: 0,
                                            },
                                            "& .MuiInputBase-input:focus": {
                                              color:
                                                "var(--HighlightedText_Stroke)",
                                              borderBottom:
                                                "2px solid var(--HighlightedText_Stroke)",
                                              backgroundColor: "transparent",
                                              fontWeight: "700 !important",
                                              "& .MuiSvgIcon-root": {
                                                color:
                                                  "var(--HighlightedText_Stroke) !important",
                                              },
                                            },
                                            "& .MuiInputBase-input:focus .MuiSvgIcon-root":
                                              {
                                                color:
                                                  "var(--HighlightedText_Stroke)", //not working
                                              },
                                            "& .MuiSvgIcon-root": {
                                              color: "var(--PrimaryText)",
                                            },
                                            "& .MuiNativeSelect-select": {
                                              paddingTop: 0,
                                              paddingBottom: 0,
                                            },
                                            "& .MuiNativeSelect-select option":
                                              {
                                                backgroundColor:
                                                  "var(--dropdown-bg) !important",
                                                fontSize: "18px",
                                                fontFamily: "Roboto",
                                                fontWeight: 400,
                                                color:
                                                  "var(--PrimaryText) !important",
                                                borderBottom:
                                                  "2px solid var(--HighlightedText_Stroke)", //not working
                                              },
                                            "& .MuiNativeSelect-select option:checked":
                                              {
                                                backgroundColor:
                                                  "var(--dropdown-bg) !important",
                                                color:
                                                  "var(--White) !important",
                                                fontWeight: "700 !important",
                                                borderColor:
                                                  "2px solid var(--HighlightedText_Stroke)",
                                              },
                                            "& .MuiInputBase-input option:hover":
                                              {
                                                backgroundColor:
                                                  "#005D8F !important",
                                              },
                                          }}
                                          MenuProps={{
                                            PaperProps: {
                                              sx: {
                                                width: "100px",
                                                bgcolor:
                                                  themechange === "dark"
                                                    ? "#3C3C3C"
                                                    : "#C1C1C1",
                                                borderBottom:
                                                  "2px solid #008CD7",
                                                borderRadius: 0,
                                                boxShadow: "none",
                                                maxHeight: "250px",
                                                overflow: "auto",
                                                color:
                                                  themechange === "dark"
                                                    ? "#FFFFFF"
                                                    : "#3C3C3C",
                                              },
                                            },
                                          }}
                                          label=""
                                          value={"="}
                                          disabled={true}
                                          onChange={(e) =>
                                            handleConditionChange(
                                              index,
                                              "condition",
                                              e.target.value,
                                            )
                                          }
                                        >
                                          {condition.type == "True" && (
                                            <MenuItem
                                              sx={{ paddingLeft: 1 }}
                                              value={"="}
                                            >
                                              {"="}
                                            </MenuItem>
                                          )}
                                          {condition.type == "False" && (
                                            <MenuItem
                                              sx={{ paddingLeft: 1 }}
                                              value={"="}
                                            >
                                              {"="}
                                            </MenuItem>
                                          )}
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      {/* <Box className="config-form-box" >
                                                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Name</Typography>
                                                                    <CustomTextField id={'negative-feedback'} selected={handleGatewayName} defaultValue={gatewayno[props.index].data.GatewayName} width={224}/> 
                                                                </Box>*/}
                                      <TextField
                                        label=""
                                        value={condition.type == "True" ? 1 : 0}
                                        variant="standard"
                                        type="number"
                                        disabled={true}
                                        onChange={(e) =>
                                          handleConditionChange(
                                            index,
                                            "setpoint1",
                                            e.target.value,
                                          )
                                        }
                                        sx={{
                                          width: "94px",
                                          "& .MuiInputBase-input:focus": {
                                            color: "#008CD7",
                                          },
                                          "& .MuiInputBase-root": {
                                            fontFamily: "Roboto",
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            color:
                                              themechange === "light"
                                                ? "#3C3C3C"
                                                : "#FFFFFF",
                                          },
                                          "& .MuiInput-root .MuiInputBase-input":
                                            {},
                                          "& .MuiInputBase-root::before": {
                                            borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                          },
                                          "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                            {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                          "& .MuiInputBase-root::after": {
                                            borderBottom: "2px solid #008CD7",
                                          },
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      {/* <Box className="config-form-box" >
                                                                    <Typography  style={{ fontSize: '18px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Gateway Name</Typography>
                                                                    <CustomTextField id={'negative-feedback'} selected={handleGatewayName} defaultValue={gatewayno[props.index].data.GatewayName} width={224}/> 
                                                                </Box>*/}
                                      <TextField
                                        label=""
                                        value={condition.setpoint2}
                                        variant="standard"
                                        type="number"
                                        onChange={(e) =>
                                          handleConditionChange(
                                            index,
                                            "setpoint2",
                                            e.target.value,
                                          )
                                        }
                                        disabled={true}
                                        sx={{
                                          width: "94px",
                                          "& .MuiInputBase-input:focus": {
                                            color: "#008CD7",
                                          },
                                          "& .MuiInputBase-root": {
                                            fontFamily: "Roboto",
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            color:
                                              themechange === "light"
                                                ? "#3C3C3C"
                                                : "#FFFFFF",
                                          },
                                          "& .MuiInput-root .MuiInputBase-input":
                                            {},
                                          "& .MuiInputBase-root::before": {
                                            borderBottom:
                                              condition.type == "Ranges"
                                                ? `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`
                                                : `1px dotted ${"#7E7E7E"}`,
                                          },
                                          "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                            {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                          "& .MuiInputBase-root::after": {
                                            borderBottom: "2px solid #008CD7",
                                          },
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <FormControl
                                        variant="standard"
                                        sx={{ marginTop: "0px", minWidth: 120 }}
                                      >
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          IconComponent={KeyboardArrowDownIcon}
                                          sx={{
                                            "&:before": {
                                              borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                            },
                                            "&:hover:not(.Mui-disabled):before":
                                              {
                                                borderBottom:
                                                  "2px solid #008CD7",
                                              },
                                            "&:after": {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                            margin: 0,
                                            padding: 0,
                                            width: "193px",
                                            fontSize: "18px",
                                            fontFamily: "Roboto",
                                            fontWeight: "700 !important",
                                            color: "var(--PrimaryText)",
                                            "& .MuiInputBase-input": {
                                              paddingLeft: 0,
                                            },
                                            "& .MuiInputBase-input:focus": {
                                              color:
                                                "var(--HighlightedText_Stroke)",
                                              borderBottom:
                                                "2px solid var(--HighlightedText_Stroke)",
                                              backgroundColor: "transparent",
                                              fontWeight: "700 !important",
                                              "& .MuiSvgIcon-root": {
                                                color:
                                                  "var(--HighlightedText_Stroke) !important",
                                              },
                                            },
                                            "& .MuiInputBase-input:focus .MuiSvgIcon-root":
                                              {
                                                color:
                                                  "var(--HighlightedText_Stroke)", //not working
                                              },
                                            "& .MuiSvgIcon-root": {
                                              color: "var(--PrimaryText)",
                                            },
                                            "& .MuiNativeSelect-select": {
                                              paddingTop: 0,
                                              paddingBottom: 0,
                                            },
                                            "& .MuiNativeSelect-select option":
                                              {
                                                backgroundColor:
                                                  "var(--dropdown-bg) !important",
                                                fontSize: "18px",
                                                fontFamily: "Roboto",
                                                fontWeight: 400,
                                                color:
                                                  "var(--PrimaryText) !important",
                                                borderBottom:
                                                  "2px solid var(--HighlightedText_Stroke)", //not working
                                              },
                                            "& .MuiNativeSelect-select option:checked":
                                              {
                                                backgroundColor:
                                                  "var(--dropdown-bg) !important",
                                                color:
                                                  "var(--White) !important",
                                                fontWeight: "700 !important",
                                                borderColor:
                                                  "2px solid var(--HighlightedText_Stroke)",
                                              },
                                            "& .MuiInputBase-input option:hover":
                                              {
                                                backgroundColor:
                                                  "#005D8F !important",
                                              },
                                          }}
                                          MenuProps={{
                                            PaperProps: {
                                              sx: {
                                                width: "40px",
                                                bgcolor:
                                                  themechange === "dark"
                                                    ? "#3C3C3C"
                                                    : "#C1C1C1",
                                                borderBottom:
                                                  "2px solid #008CD7",
                                                borderRadius: 0,
                                                boxShadow: "none",
                                                maxHeight: "250px",
                                                overflow: "auto",
                                                color:
                                                  themechange === "dark"
                                                    ? "#FFFFFF"
                                                    : "#3C3C3C",
                                              },
                                            },
                                          }}
                                          onChange={(e) =>
                                            handleConditionChange(
                                              index,
                                              "alarmpriority",
                                              e.target.value,
                                            )
                                          }
                                          label="Alarm Priority"
                                          value={condition.alarmpriority}
                                        >
                                          <MenuItem value={"Highest"}>
                                            {"Highest"}
                                          </MenuItem>
                                          <MenuItem value={"High"}>
                                            {"High"}
                                          </MenuItem>
                                          <MenuItem value={"Medium"}>
                                            {"Medium"}
                                          </MenuItem>
                                          <MenuItem value={"Low"}>
                                            {"Low"}
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <TextField
                                        label=""
                                        value={condition.abnormalmessage}
                                        variant="standard"
                                        sx={{
                                          width: "94px",
                                          "& .MuiInputBase-input:focus": {
                                            color: "#008CD7",
                                          },
                                          "& .MuiInputBase-root": {
                                            fontFamily: "Roboto",
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            color:
                                              themechange === "light"
                                                ? "#3C3C3C"
                                                : "#FFFFFF",
                                          },
                                          "& .MuiInput-root .MuiInputBase-input":
                                            {},
                                          "& .MuiInputBase-root::before": {
                                            borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                          },
                                          "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                            {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                          "& .MuiInputBase-root::after": {
                                            borderBottom: "2px solid #008CD7",
                                          },
                                        }}
                                        onChange={(e) =>
                                          handleConditionChange(
                                            index,
                                            "abnormalmessage",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </TableCell>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      sx={{
                                        padding: "0px",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                        paddingTop: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <TextField
                                        label=""
                                        value={condition.normalmessage}
                                        variant="standard"
                                        sx={{
                                          width: "94px",
                                          "& .MuiInputBase-input:focus": {
                                            color: "#008CD7",
                                          },
                                          "& .MuiInputBase-root": {
                                            fontFamily: "Roboto",
                                            fontSize: "16px",
                                            fontWeight: "700",
                                          },
                                          "& .MuiInput-root .MuiInputBase-input":
                                            {},
                                          "& .MuiInputBase-root::before": {
                                            borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                          },
                                          "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                            {
                                              borderBottom: "2px solid #008CD7",
                                            },
                                          "& .MuiInputBase-root::after": {
                                            borderBottom: "2px solid #008CD7",
                                          },
                                        }}
                                        onChange={(e) =>
                                          handleConditionChange(
                                            index,
                                            "normalmessage",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </TableCell>
                                    {/* <TableCell component="th" scope="row" sx={{ padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"2px",paddingBottom:"2px"}}>
                                                                <Button sx={{ width:"20px",height:"20px",padding:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none"}} variant="text" onClick={() => handleRemoveRow(index)} disableTouchRipple elevation={0}><LK_Delete color={"#005C8E"} width={"20px"} height={"20px"}/></Button>
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" sx={{ alignItems:"baseline",padding:"0px",fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"2px",paddingBottom:"2px"}}>
                                                                {<div style={{display:"flex", marginTop:0, paddingTop:0}}>
                                                                    <CustomActionButton children={'Add Row'} func={handleAddRow1} />
                                                                </div>}
                                                            </TableCell> */}
                                  </TableRow>
                                );
                              } else {
                                console.error(
                                  "Invalid condition object:",
                                  condition,
                                );
                                return null; // Skip rendering invalid rows
                              }
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                  {/* <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                                        <DialogTitle>Overlapping Conditions Detected</DialogTitle>
                                        <DialogContent>
                                            {conflictingconditions.map((conflict, index) => (
                                                <Typography key={index}>
                                                    Conflict for Condition {conflict.condition} with setpoint {conflict.setpoint1}
                                                </Typography>
                                            ))}
                                            <Typography>Do you want to remove these conflicting conditions?</Typography>
                                        </DialogContent>
                                        <DialogActions>
                                        <Button onClick={handleDeleteConflicts} color="primary">
                                            Yes, Delete Conflicts
                                        </Button>
                                        <Button onClick={() => setOpenDialog(false)} color="secondary">
                                            No, I'll Edit Manually
                                        </Button>
                                        </DialogActions>
                                    </Dialog> */}
                </>
              )}
              <Dialog
                open={open}
                onClose={handleClose}
                BackdropProps={{
                  sx: {
                    backgroundColor:
                      themechange == "light"
                        ? "rgba(0,0,0,0.3)"
                        : "rgba(255,255,255,0.3)",
                  },
                }}
                sx={{
                  "& .MuiDialog-paper": {
                    borderTopLeftRadius: "40px",
                    borderTopRightRadius: "40px",
                    backgroundColor:
                      themechange == "light" ? "#FFFFFF" : "#19191B",
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    color: "#FFFFFF",
                    backgroundColor: "#005C8E",
                    margin: "5px",
                    borderRadius: "100px",
                  }}
                >
                  {"Confirm Save Action"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    sx={{
                      color: themechange == "light" ? "#19191B" : "#FFFFFF",
                    }}
                  >
                    <h5>Overlapping Conditions Groups</h5>
                    {conflictingConditionsGroups.map((group, index) => (
                      <div key={index}>
                        <h5>Group {index + 1}:</h5>
                        <ul>
                          {group.map((condition, i) => (
                            <li key={i}>
                              {condition.lowerCondition}{" "}
                              {condition.lowerBound === -Infinity
                                ? "-Infinity"
                                : condition.lowerBound}{" "}
                              to{" "}
                              {condition.upperBound === Infinity
                                ? "Infinity"
                                : condition.upperBound}{" "}
                              {condition.upperCondition}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                    Are you sure you want to save the changes?
                  </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center" }}>
                  <Button
                    onClick={handleSaveConditions}
                    sx={{
                      outline: "none !important",
                      boxShadow: "none",
                      height: "35px",
                      width: "125px",
                      fontSize: "16px",
                      textTransform: "capitalize",
                      marginRight: "5px",
                      backgroundColor: "#005C8E",
                      borderRadius: "20px",
                    }}
                    variant="contained"
                    autoFocus
                  >
                    Confirm
                  </Button>
                  <CustomCancelButton
                    onClick={handleClose}
                    buttonText={"Cancel"}
                  ></CustomCancelButton>
                </DialogActions>
              </Dialog>

              <Dialog
                open={openAtLeastOneConditionDialog}
                onClose={handleCloseAtLeastOneConditionDialog}
                BackdropProps={{
                  sx: {
                    backgroundColor:
                      themechange == "light"
                        ? "rgba(0,0,0,0.3)"
                        : "rgba(255,255,255,0.3)",
                  },
                }}
                sx={{
                  "& .MuiDialog-paper": {
                    borderTopLeftRadius: "40px",
                    borderTopRightRadius: "40px",
                    backgroundColor:
                      themechange == "light" ? "#FFFFFF" : "#19191B",
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    color: "#FFFFFF",
                    backgroundColor: "#005C8E",
                    margin: "5px",
                    borderRadius: "100px",
                  }}
                >
                  Single Condition
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    sx={{
                      color: themechange == "light" ? "#19191B" : "#FFFFFF",
                    }}
                  >
                    At least one condition is required
                  </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center" }}>
                  <Button
                    onClick={handleConfirmationAtLeastOneConditionDialog}
                    sx={{
                      outline: "none !important",
                      boxShadow: "none",
                      height: "35px",
                      width: "125px",
                      fontSize: "16px",
                      textTransform: "capitalize",
                      marginRight: "5px",
                      backgroundColor: "#005C8E",
                      borderRadius: "20px",
                    }}
                    variant="contained"
                    autoFocus
                  >
                    Ok
                  </Button>
                  <CustomCancelButton
                    width={"125px"}
                    onClick={handleCloseAtLeastOneConditionDialog}
                    buttonText={"Cancel"}
                  ></CustomCancelButton>
                </DialogActions>
              </Dialog>

              <Dialog
                open={openMaxConditionDialog}
                onClose={handleCloseMaxConditionDialog}
                BackdropProps={{
                  sx: {
                    backgroundColor:
                      themechange == "light"
                        ? "rgba(0,0,0,0.3)"
                        : "rgba(255,255,255,0.3)",
                  },
                }}
                sx={{
                  "& .MuiDialog-paper": {
                    borderTopLeftRadius: "40px",
                    borderTopRightRadius: "40px",
                    backgroundColor:
                      themechange == "light" ? "#FFFFFF" : "#19191B",
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    color: "#FFFFFF",
                    backgroundColor: "#005C8E",
                    margin: "5px",
                    borderRadius: "100px",
                  }}
                >
                  Maximum Conditions
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    sx={{
                      color: themechange == "light" ? "#19191B" : "#FFFFFF",
                    }}
                  >
                    We can enter maximum 10 conditions
                  </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center" }}>
                  <Button
                    onClick={handleConfirmationMaxConditionDialog}
                    sx={{
                      outline: "none !important",
                      boxShadow: "none",
                      height: "35px",
                      width: "125px",
                      fontSize: "16px",
                      textTransform: "capitalize",
                      marginRight: "5px",
                      backgroundColor: "#005C8E",
                      borderRadius: "20px",
                    }}
                    variant="contained"
                    autoFocus
                  >
                    Ok
                  </Button>
                  <CustomCancelButton
                    width={"125px"}
                    onClick={handleCloseMaxConditionDialog}
                    buttonText={"Cancel"}
                  ></CustomCancelButton>
                </DialogActions>
              </Dialog>

              {/* <Dialog
                                open={openAlarmUpdatedandSaved}
                                onClose={handleCloseAlarmUpdatedandSaved}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                            >
                                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Single Condition</DialogTitle>
                                    <DialogContent >
                                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                            Successfully updated database
                                        </DialogContentText>
                                    </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}> 
                                    <Button onClick={handleConfirmationAlarmUpdatedandSaved} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Ok
                                    </Button>
                                    <CustomCancelButton width={"125px"} onClick={handleCloseAlarmUpdatedandSaved} buttonText={'Cancel'}></CustomCancelButton>
                                </DialogActions>
                            </Dialog> */}

              <CustomDialogBox
                dialogTitle={"Alert Rule Updation"}
                dialogText={openAlarmUpdatedandSavedMsg}
                openDialog={openAlarmUpdatedandSaved}
                handleCloseDialog={handleCloseAlarmUpdatedandSaved}
                handleConfirmDialog={handleConfirmationAlarmUpdatedandSaved}
                confirmText={"Ok"}
                cancelText={"Cancel"}
                type={"Success"}
              />

              <CustomDialogBox
                dialogTitle={"Alert Rule Updation"}
                dialogText={openAlarmUpdatedandSavedMsgErr}
                openDialog={openAlarmUpdatedandSavedErr}
                handleCloseDialog={handleCloseAlarmUpdatedandSavedErr}
                handleConfirmDialog={handleConfirmationAlarmUpdatedandSavedErr}
                confirmText={"Ok"}
                cancelText={"Cancel"}
                type={"Error"}
              />
              {/*
                            <Dialog
                                open={openDuplicateAlarm}
                                onClose={handleCloseDuplicateAlarm}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                            >
                                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Single Condition</DialogTitle>
                                    <DialogContent >
                                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                            Duplicate entry - Try again 
                                        </DialogContentText>
                                    </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}> 
                                    <Button onClick={handleConfirmationDuplicateAlarm} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Ok
                                    </Button>
                                    <CustomCancelButton width={"125px"} onClick={handleCloseDuplicateAlarm}>Cancel</CustomCancelButton>
                                </DialogActions>
                            </Dialog> */}
            </div>
            <div style={{ marginLeft: "25px", alignItems: "end" }}>
              <Typography
                sx={{
                  marginRight: "20px",
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  color: "var(--SecondaryText)",
                  fontWeight: 400,
                  marginLeft: "14px",
                  textAlign: "left",
                }}
              >
                Select User Group to send Notification
              </Typography>
              <Box
                style={{
                  border: "1px solid #008CD7",
                  display: "flex",
                  flexDirection: "column",
                  height: "347px",
                  width: "90%",
                  padding: "0px 16px",
                  overflowY: "scroll",
                }}
              >
                {userGroupsError == true && (
                  <Typography
                    sx={{
                      marginRight: "20px",
                      fontSize: "16px",
                      fontFamily: "Roboto",
                      color: "var(--SecondaryText)",
                      fontWeight: 400,
                      marginLeft: "0px",
                      textAlign: "left",
                    }}
                  >
                    User Groups not Found
                  </Typography>
                )}
                {userGroupsError == false &&
                userGroups != null &&
                userGroups != undefined ? (
                  userGroups.length > 0 ? (
                    userGroups.map((objecttreeview, index) => {
                      if (objecttreeview.hasOwnProperty("ProjectID")) {
                        return (
                          <div style={{ display: "block" }} key={index}>
                            <SimpleTreeView
                              sx={{
                                color: "var(--SecondaryText)",
                                "& .MuiTreeItem-label .MuiTreeItem-content": {
                                  fontSize: "16px",
                                  fontWeight: 400,
                                  color: "red",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                },
                              }}
                              defaultCollapseIcon="-"
                              defaultExpandIcon="+"
                            >
                              <TreeItem
                                itemId={objecttreeview["id"]}
                                label={
                                  <Typography
                                    sx={{
                                      display: "flex",
                                      alignItems: "left",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    <Checkbox
                                      checkedIcon={<CheckBoxOutlinedIcon />}
                                      style={{ color: "var(--SecondaryText)" }}
                                      checked={checkedNodes.some(
                                        (checkedNode) =>
                                          checkedNode.id ===
                                          objecttreeview["id"],
                                      )}
                                      sx={{
                                        padding: 0,
                                        margin: 0,
                                        color: "var(--HighlightedText_Stroke)",
                                        "& .MuiSvgIcon-root": {
                                          fontSize: "20px",
                                          color:
                                            "var(--HighlightedText_Stroke)",
                                        },
                                      }}
                                      onChange={(event) =>
                                        handleCheck(
                                          event,
                                          objecttreeview,
                                          objecttreeview["id"],
                                          objecttreeview["groupName"],
                                          objecttreeview["id"],
                                        )
                                      }
                                    />

                                    <span
                                      style={{ color: "var(--SecondaryText)" }}
                                    >
                                      {objecttreeview["groupName"]}
                                    </span>
                                  </Typography>
                                }
                                sx={{
                                  "& .MuiTreeItem-label": {
                                    fontSize: "16px",
                                    fontWeight: 400,
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  },
                                }}
                              >
                                {objecttreeview["users"].map(
                                  (currentGroup, index) =>
                                    renderTreeNodes(
                                      currentGroup,
                                      checkedNode,
                                      objecttreeview["groupName"],
                                      objecttreeview["id"],
                                    ),
                                )}
                              </TreeItem>
                            </SimpleTreeView>
                          </div>
                        );
                      } else {
                        <></>;
                      }
                    })
                  ) : (
                    <></>
                  )
                ) : (
                  <></>
                )}
              </Box>
            </div>
            <div style={{ marginLeft: "25px" }}>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "var(--SecondaryText)",
                    marginRight: "30px",
                  }}
                >
                  {"Enable Notification as per Priority"}
                </Typography>
                <Checkbox
                  checkedIcon={<CheckBoxOutlinedIcon />}
                  style={{ color: "var(--SecondaryText)" }}
                  checked={enablehighestprioritynotification}
                  sx={{
                    padding: 0,
                    margin: 0,
                    color: "var(--HighlightedText_Stroke)",
                    "& .MuiSvgIcon-root": {
                      fontSize: "20px",
                      color: "var(--HighlightedText_Stroke)",
                    },
                  }}
                  onChange={(event) => handlePriorityCheck(event, "Highest")}
                />

                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "var(--SecondaryText)",
                    marginRight: "30px",
                    marginRight: "30px",
                  }}
                >
                  {"Highest"}
                </Typography>

                <Checkbox
                  checkedIcon={<CheckBoxOutlinedIcon />}
                  style={{ color: "var(--SecondaryText)" }}
                  checked={enablehighprioritynotification}
                  sx={{
                    padding: 0,
                    margin: 0,
                    color: "var(--HighlightedText_Stroke)",
                    "& .MuiSvgIcon-root": {
                      fontSize: "20px",
                      color: "var(--HighlightedText_Stroke)",
                    },
                  }}
                  onChange={(event) => handlePriorityCheck(event, "High")}
                />

                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "var(--SecondaryText)",
                    marginRight: "30px",
                  }}
                >
                  {"High"}
                </Typography>
                <Checkbox
                  checkedIcon={<CheckBoxOutlinedIcon />}
                  style={{ color: "var(--SecondaryText)" }}
                  checked={enablemediumprioritynotification}
                  sx={{
                    padding: 0,
                    margin: 0,
                    color: "var(--HighlightedText_Stroke)",
                    "& .MuiSvgIcon-root": {
                      fontSize: "20px",
                      color: "var(--HighlightedText_Stroke)",
                    },
                  }}
                  onChange={(event) => handlePriorityCheck(event, "Medium")}
                />

                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "var(--SecondaryText)",
                    marginRight: "30px",
                  }}
                >
                  {"Medium"}
                </Typography>
                <Checkbox
                  checkedIcon={<CheckBoxOutlinedIcon />}
                  style={{ color: "var(--SecondaryText)" }}
                  checked={enablelowprioritynotification}
                  sx={{
                    padding: 0,
                    margin: 0,
                    color: "var(--HighlightedText_Stroke)",
                    "& .MuiSvgIcon-root": {
                      fontSize: "20px",
                      color: "var(--HighlightedText_Stroke)",
                    },
                  }}
                  onChange={(event) => handlePriorityCheck(event, "Low")}
                />
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "var(--SecondaryText)",
                    marginRight: "30px",
                  }}
                >
                  {"Low"}
                </Typography>
                <div style={{ flexGrow: 1 }}></div>

                <Checkbox
                  checkedIcon={<CheckBoxOutlinedIcon />}
                  style={{ color: "var(--SecondaryText)" }}
                  checked={enableAlert == true ? true : false}
                  sx={{
                    padding: 0,
                    margin: 0,
                    color: "var(--HighlightedText_Stroke)",
                    "& .MuiSvgIcon-root": {
                      fontSize: "20px",
                      color: "var(--HighlightedText_Stroke)",
                    },
                  }}
                  onChange={(event) => handleAlertEnable(event)}
                />

                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "var(--SecondaryText)",
                    marginRight: "10px",
                  }}
                >
                  {"Enable Alert Rule"}
                </Typography>

                <Checkbox
                  checkedIcon={<CheckBoxOutlinedIcon />}
                  style={{ color: "var(--SecondaryText)" }}
                  checked={sendMessage == true ? true : false}
                  sx={{
                    padding: 0,
                    margin: 0,
                    color: "var(--HighlightedText_Stroke)",
                    "& .MuiSvgIcon-root": {
                      fontSize: "20px",
                      color: "var(--HighlightedText_Stroke)",
                    },
                  }}
                  onChange={(event) => handleSendMessage(event)}
                />

                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "var(--SecondaryText)",
                    marginRight: "10px",
                  }}
                >
                  {"Enable Message"}
                </Typography>

                <Checkbox
                  checkedIcon={<CheckBoxOutlinedIcon />}
                  style={{ color: "var(--SecondaryText)" }}
                  checked={sendEmail == true ? true : false}
                  sx={{
                    padding: 0,
                    margin: 0,
                    color: "var(--HighlightedText_Stroke)",
                    "& .MuiSvgIcon-root": {
                      fontSize: "20px",
                      color: "var(--HighlightedText_Stroke)",
                    },
                  }}
                  onChange={(event) => handleSendEmail(event)}
                />

                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "var(--SecondaryText)",
                    marginRight: "95px",
                  }}
                >
                  {"Enable Email"}
                </Typography>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "var(--SecondaryText)",
                    marginRight: "30px",
                  }}
                >
                  {"Note: Maximum 10 conditions allowed"}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

{
  /**/
}
